import { useQuery } from '@tanstack/react-query';

import { getCrystalsData, ICrystalsData } from '../api/charts/crystals';
import { IProfile } from '../types/Profile';

export const useCrystalsData = (profile: IProfile) => {
  return useQuery<ICrystalsData>({
    queryKey: ['crystalsData', profile.token],
    queryFn: () => getCrystalsData(profile.token),
    enabled: !!profile?.token,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
